export default [
    {
        text: '#',
        value: 'id',
        width: '5%',
    },
    {
        text: 'Código',
        value: 'code',
    },
    {
        text: 'Glosa',
        value: 'comment',
    },
    {
        text: 'responsable',
        value: 'generatorUserName',
    },
    {
        text: 'Balance',
        align: 'right',
        value: 'balance',
        format: 'currency',
    },
    {
        text: 'Estado',
        value: 'accountingSeatStatus',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                small: true,
            },
        },
    },
    {
        text: 'fecha',
        value: 'accounting_date',
        align: 'right',
        format: 'date',
        width: '5%',
    },
]
